import React, {useState} from 'react'
import { DataPoint } from "../../Pages/Live";

interface StatsBoxProps{
    data:DataPoint[]
}
function StatsBox(props:StatsBoxProps){
    const {data} = props
    const [stats, setStats] = useState<Map<string, {min:number, max:number, avg:number}>>(new Map())
    function calculateStats(data:DataPoint[]){
        const statsMap = new Map<string, {min:number, max:number, avg:number}>()
        data.forEach(dp=>{
            Object.keys(dp).forEach(key=>{
                if(key !== 'timestamp'){
                    const value = dp[key]
                    if(!statsMap.has(key)){
                        statsMap.set(key, {min:value, max:value, avg:value})
                    }else{
                        const stat = statsMap.get(key)
                        stat.min = Math.min(stat.min, value)
                        stat.max = Math.max(stat.max, value)
                        stat.avg = (stat.avg + value) / 2
                        statsMap.set(key, stat)
                    }
                }
            })
        })
        setStats(statsMap)
    }
    React.useEffect(()=>{
        calculateStats(data)
    }, [data])
    return (
        <div>
            <h3>Stats</h3>
            <table>
                <thead>
                    <tr>
                        <th>Tag</th>
                        <th>Min</th>
                        <th>Max</th>
                        <th>Avg</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.from(stats.entries()).map(([tag, stat])=>(
                        <tr key={tag}>
                            <td>{tag}</td>
                            <td>{stat.min.toFixed(2)}</td>
                            <td>{stat.max.toFixed(2)}</td>
                            <td>{stat.avg.toFixed(2)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default StatsBox